import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Tooltip from '../../../../components/Tooltip';

const BodyFields = ({ details, fields }) => (
  <td className="users__fields">
    {fields?.map((field, index) => {
      const Tag = 'a';
      const linkProps = {};
      const itemProps = {
        icon: '',
        text: details?.find((detail) => detail.name === field)?.value || '',
      };

      switch (field) {
      case 'first_name':
        itemProps.icon = 'fa fa-user';
        const firstname = details?.find((item) => item.name === 'first_name')?.value;
        const lastname = details?.find((item) => item.name === 'last_name')?.value;
        itemProps.text = `${firstname || ''} ${lastname || ''}`;
        break;

      case 'phone':
        linkProps.href = `tel:${itemProps.text}`;
        itemProps.icon = 'fa fa-phone';
        break;

      case 'whatsapp':
        linkProps.href = `https://wa.me/${itemProps.text}`;
        linkProps.target = '_blank';
        linkProps.rel = 'noopener noreferrer';
        itemProps.icon = 'fa fa-whatsapp';
        break;

      case 'telegram':
        linkProps.href = `${window.location.origin}/anon.ws?r=http://t.me/${itemProps.text}`;
        linkProps.target = '_blank';
        linkProps.rel = 'noopener noreferrer';
        itemProps.icon = 'fa fa-telegram';
        break;

      case 'skype':
        linkProps.href = `skype:${itemProps.text}?chat`;
        itemProps.icon = 'fa fa-skype';
        break;

      case 'website':
        linkProps.href = `${window.location.origin}/anon.ws?r=${itemProps.text}`;
        linkProps.target = '_blank';
        linkProps.rel = 'noopener noreferrer';
        itemProps.icon = 'fa fa-globe';
        break;

      default:
        return;
      }

      linkProps.className = classNames('users__fields-link', { 'users__fields-link--disabled': !itemProps.text.trim() });

      return (
        <Tag {...linkProps} key={index}>
          <Tooltip placement="top" tooltipClass="tooltip__top tooltip__wide" text={itemProps.text}>
            <span className={itemProps.icon} />
          </Tooltip>
        </Tag>
      );
    })}
  </td>
);

BodyFields.propTypes = {
  details: PropTypes.array,
  fields: PropTypes.array,
};

export default BodyFields;
